import actionTypes from 'constants/actionTypes'


export default [
  actionTypes.BOOKMARKS.ONE.CREATE,
  actionTypes.NODES.ONE.CREATE,
  actionTypes.EDGES.ONE.CREATE,
  actionTypes.KINDS.ONE.CREATE
]
